import { Pipe, PipeTransform } from '@angular/core';
import { ShellDomainProvider } from '@ecap3/core';

@Pipe({name: 'customCurrency'})

export class CustomCurrencyPipe implements PipeTransform {
  // this pipe by-default uses (dot'.') after thousand place and (comma ',') after decimal place 
  transform(val: number): string {

    let transformed: string;
    if (val !== undefined && val !== null) {

      transformed = val.toString();

      const customNumberFormat = ShellDomainProvider['api'].customNumberFormat;
      let decimalPlaceChar, thousandPlaceChar;    
        
      if (customNumberFormat) {
        decimalPlaceChar = customNumberFormat[0];
        thousandPlaceChar = customNumberFormat[1];
      }else{
        decimalPlaceChar = ",";
        thousandPlaceChar = ".";
      }

      transformed = transformed.split(",").map(s => s.split(".").join(decimalPlaceChar)).join(thousandPlaceChar);

      const isShowDecimalPartForAll = ShellDomainProvider['api'].isShowDecimalPartForAll;

      if (ShellDomainProvider['api'].fixedDecimalPoint) {
        let transformedAfterPoint = transformed.split(',');
        if (transformedAfterPoint[1])
        {
          if(isShowDecimalPartForAll)
          {
            transformedAfterPoint[1] = transformedAfterPoint[1]+'000000000';
          }
        
          transformed = transformedAfterPoint[0] + ',' + transformedAfterPoint[1].slice(0, parseInt(ShellDomainProvider['api'].fixedDecimalPoint));
        }
        else{
          transformedAfterPoint.push('000000000');
          if(isShowDecimalPartForAll){
            transformed = transformedAfterPoint[0] + ',' + transformedAfterPoint[1].slice(0, parseInt(ShellDomainProvider['api'].fixedDecimalPoint));
          }
        }
         
      }

      return transformed;

    } else {
      return "";
    }
  }
}
